import axios from "axios";

import { CompletionStatus } from "./restaurant-equippers.types";

export namespace RestaurantEquippersService {
  export function getCompletionStatus(
    email: string
  ): Promise<CompletionStatus | null> {
    const params = { email };

    return axios
      .get<CompletionStatus>(
        `${window.FKL.yentaServicesApiUrl}/restaurant-equippers/status`,
        { params }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error(error.response?.data?.message ?? error.message);
        return null;
      });
  }
}
